import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createReferenceToNode, useAppContext, } from '@datapad/data-model';
import { Add, Close } from '@mui/icons-material';
import { Autocomplete, Box, IconButton, ListSubheader, TextField as MuiTextField, Typography, } from '@mui/material';
import React from 'react';
import { CharacterList } from './CharacterList.js';
import { CharacterListEntry } from './CharacterListEntry.js';
import { EditableListView } from './EditableListView.js';
export function EditableCharacterList(props) {
    const { characters, canEdit = false, title } = props;
    const appContext = useAppContext();
    const resolvedCharacters = React.useMemo(() => {
        return [...characters].map((ref) => appContext.getCharacter(ref));
    }, [characters, appContext]);
    const handleCharacterClick = React.useCallback((character) => {
        appContext.handleCharacterLink(character);
    }, [appContext]);
    if (!canEdit) {
        if (resolvedCharacters.length === 0) {
            return _jsx(_Fragment, {});
        }
        return (_jsx(CharacterList, { title: title, characters: resolvedCharacters, onClick: handleCharacterClick, button: true, dense: true }));
    }
    return (_jsxs(Box, { children: [title && (_jsx(ListSubheader, { component: "div", disableSticky: true, children: title })), _jsx(EditableListView, { list: characters, view: (ref) => {
                    const character = appContext.getCharacter(ref);
                    return (_jsx(CharacterListEntry, { character: character, onClick: () => handleCharacterClick(character), button: true, dense: true }));
                }, getKeyForItem: (ref) => ref.id, insertionForm: (list, close) => (_jsx(CharacterInsertForm, { list: list, existingIds: [...characters].map((ref) => ref.id), onClose: close })), canEdit: false, canRemove: true, canReorder: true })] }));
}
function CharacterInsertForm(props) {
    const { list, existingIds, onClose } = props;
    const appContext = useAppContext();
    const [selectedCharacter, setSelectedCharacter] = React.useState(null);
    const availableCharacters = React.useMemo(() => {
        const allCharacters = appContext.getAllCharacters();
        return allCharacters.filter((char) => !existingIds.includes(char.id));
    }, [appContext, existingIds]);
    const handleAdd = React.useCallback(() => {
        if (selectedCharacter) {
            const ref = createReferenceToNode(selectedCharacter);
            list.insertAtEnd(ref);
            setSelectedCharacter(null);
            onClose();
        }
    }, [selectedCharacter, list, onClose]);
    const handleKeyDown = React.useCallback((event) => {
        if (event.key === 'Escape') {
            onClose();
        }
        else if (event.key === 'Enter' && selectedCharacter) {
            event.preventDefault();
            handleAdd();
        }
    }, [onClose, selectedCharacter, handleAdd]);
    if (availableCharacters.length === 0) {
        return (_jsxs(Box, { sx: { display: 'flex', alignItems: 'center', gap: 1, p: 1 }, children: [_jsx(Typography, { variant: "body2", color: "text.secondary", children: "No more characters available" }), _jsx(IconButton, { size: "small", onClick: onClose, "aria-label": "close", children: _jsx(Close, { fontSize: "small" }) })] }));
    }
    return (_jsxs(Box, { sx: { display: 'flex', alignItems: 'center', gap: 1, p: 1 }, children: [_jsx(Autocomplete, { size: "small", options: availableCharacters, getOptionLabel: (char) => char.name, value: selectedCharacter, onChange: (_, newValue) => setSelectedCharacter(newValue), onKeyDown: handleKeyDown, renderInput: (params) => (_jsx(MuiTextField, { ...params, label: "Add character", placeholder: "Search..." })), sx: { minWidth: 200, flexGrow: 1 }, autoFocus: true }), _jsx(IconButton, { size: "small", onClick: handleAdd, color: "primary", disabled: !selectedCharacter, "aria-label": "add", children: _jsx(Add, { fontSize: "small" }) }), _jsx(IconButton, { size: "small", onClick: onClose, "aria-label": "cancel", children: _jsx(Close, { fontSize: "small" }) })] }));
}
//# sourceMappingURL=EditableCharacterList.js.map